import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { PlayerProvider } from './PlayerContext';
import { DataProvider } from './DataProvider';
import Layout from './Layout';
import Experience from './Experience';
import Projects from './Projects';
import Home from './Home';
import Blog from './Blog';
import BlogPost from './BlogPost';
import ProjectPost from './ProjectPost';
import Education from './Education';
import OfficeHours from './OfficeHours';
import Whip from './Whip';
import Tutoring from './Tutoring';
import BookTime from './BookTime';
import ThankYou from './ThankYou';
import QueuePage from './Queue/QueuePage';
import QueueRedirect from './Queue/QueueRedirect';
import SwotMap from './SwotMap';
import TechConnections from './TechConnections';

const App = () => {
  return (
    <Router>
      <DataProvider>
        <PlayerProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectPost />} />
              <Route path="/education" element={<Education />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/office-hours" element={<OfficeHours />} />
              <Route path="/whip" element={<Whip />} />
              <Route path="/tutoring" element={<Tutoring />} />
              <Route path="/book-time" element={<BookTime />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/rakshiswot" element={<SwotMap />} />
              <Route path="/connections" element={<TechConnections />} />
              <Route path="/q/autoAuthCuzDivyDaGoat67" element={<QueuePage autoAuth={true} />} />
              <Route path="/q" element={<QueuePage />} />
              <Route path="/queue" element={<QueueRedirect />} />
            </Routes>
          </Layout>
        </PlayerProvider>
      </DataProvider>
    </Router>
  );
}

export default App;
